import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function KeyboardControlKeyIcon(props: IconProps) {
    return <Icon {...props} iconKey={"keyboard_control_key"}/>
}
